/* eslint-disable */
import React, { useEffect, useState, forwardRef } from "react";
import { Helmet } from "react-helmet";
import classNames from "classnames";
import { headApi, localApi, credentials } from "utils/headApi";
import axios from "axios";
import { useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { makeStyles } from "@material-ui/core/styles";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import InshaSection from "views/InshaBanglesPage/Section/InshaSectionPro.js";
import InshaContact from "views/InshaBanglesPage/Section/InshaContact.js";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import { FiPhoneCall } from "react-icons/fi";

import presentationStyle from "assets/jss/material-kit-pro-react/views/presentationStyle.js";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";

const usePresentation = makeStyles(presentationStyle);
const useJavascript = makeStyles(javascriptStyles);
const useProduct = makeStyles(productStyle);

const Transition = forwardRef((props, ref) => (
  <Slide direction="down" ref={ref} {...props} />
));

export default function InshaPage() {
  const classes = usePresentation();
  const js = useJavascript();
  const prod = useProduct();
  const history = useHistory();

  const [mobile, setMobile] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [otpNumber, setOtpNumber] = useState("");
  const [otpNumberErr, setOtpNumberErr] = useState("");
  const [otpScreen, setOtpScreen] = useState(false);
  const [expectedOtp, setExpectedOtp] = useState("");
  const [loginModal, setLoginModal] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [userLocation, setUserLocation] = useState(null); // Store lat/lng

  const activeSession = sessionStorage.getItem("sessionData");

  // useEffect(() => {
  //   window.scrollTo(0, 0);

  //   async function fetchInitialData() {
  //     try {
  //       const statesRes = await fetch(localApi + `/admin/groupState`, {
  //         headers: { Authorization: `Basic ${credentials}` },
  //       });
  //       const stateData = await statesRes.json();
  //       setStateList(stateData.map((f) => f.state));

  //       const companyRes = await axios.get(localApi + `/admin/allList`, {
  //         headers: { Authorization: `Basic ${credentials}` },
  //       });
  //       setCompanyList(companyRes.data.AdminList.map((f) => f.company));

  //       const categoryRes = await axios.get(localApi + `/category/allList`, {
  //         headers: { Authorization: `Basic ${credentials}` },
  //       });
  //       const cats = categoryRes.data.map((f) => f.title.toLowerCase());
  //       setCategoryList([...new Set(cats)]);

  //       const parentRes = await axios.get(localApi + `/parent/allList`, {
  //         headers: { Authorization: `Basic ${credentials}` },
  //       });
  //       const parents = parentRes.data.map((f) => f.title.toLowerCase());
  //       setParentList([...new Set(parents)]);
  //     } catch (err) {
  //       console.error("Error fetching data:", err);
  //     }
  //   }

  //   fetchInitialData();

  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const userLocation = {
  //           lat: position.coords.latitude,
  //           lng: position.coords.longitude,
  //         };
  //         // silently save location, no alert or UI display
  //         console.log("userLocation", userLocation);
          
  //         sessionStorage.setItem("userLocation", JSON.stringify(userLocation));
  //       },
  //       (error) => {
  //         console.error("Geolocation error:", error);
  //         // no alert to user, just log error silently
  //       },
  //       {
  //         enableHighAccuracy: true,
  //         timeout: 10000,
  //         maximumAge: 0,
  //       }
  //     );
  //   } else {
  //     console.error("Geolocation is not supported by your browser.");
  //   }
  // }, []);


  // const handleSendOtp = () => {
  //   setMobileErr("");
  //   if (!mobile || mobile.replace(/\D/g, "").length !== 10) {
  //     setMobileErr("Please enter a valid 10-digit mobile number");
  //     return;
  //   }

  //   fetch(`${headApi}/user/sendotp?mobile=+${mobile}&type=client&webappid=1`, {
  //     method: "PUT",
  //     headers: { "Content-Type": "application/json", Accept: "application/json" },
  //   })
  //     .then((res) => res.json())
  //     .then((resp) => {
  //       if (resp.message === "Enter Registerd Mobile number") {
  //         setMobileErr("Please enter a registered mobile number");
  //       } else if (resp.error === "false") {
  //         setExpectedOtp(resp.message);
  //         setOtpScreen(true);
  //       }
  //     })
  //     .catch(console.error);
  // };

  // const handleLogin = () => {
  //   setOtpNumberErr("");
  //   if (otpNumber.length !== 6) {
  //     setOtpNumberErr("Invalid OTP");
  //     return;
  //   }

  //   fetch(
  //     `${headApi}/user/login?otp=${otpNumber}&mobile=+${mobile}&type=client`,
  //     {
  //       method: "PUT",
  //       headers: { "Content-Type": "application/json", Accept: "application/json" },
  //     }
  //   )
  //     .then((res) => res.json())
  //     .then((resp) => {
  //       if (resp.apiResponse?.error !== "false") {
  //         setOtpNumberErr("OTP verification failed");
  //       } else {
  //         sessionStorage.setItem("sessionData", JSON.stringify(resp.user));
  //         setLoginModal(false);
  //         history.push("/product-list");
  //       }
  //     })
  //     .catch(console.error);
  // };

  // const handleCallMe = () => {
  //   fetch(`${headApi}/user/callMe?mobile=+${mobile}&type=client&webappid=1`, {
  //     method: "GET",
  //     headers: { "Content-Type": "application/json", Accept: "application/json" },
  //   })
  //     .then((res) => res.json())
  //     .then((msg) => {
  //       if (msg === "Thank You for Visiting! We will reach back to you soon.") {
  //         alert(msg);
  //       }
  //     })
  //     .catch(console.error);
  // };

  return (
    <div>
      <Helmet>
        <title>Indian Bangles</title>
        <meta
          name="description"
          content="Top bangle manufacturer in Maharashtra & Karnataka"
        />
        <meta
          name="keywords"
          content="fancy bangles, party wear bangles for women, stylish gold plated bangles, trendy gold bangles, imitation bangles, designer bangles, brass gold plated bangles, casual everyday bangles, elegant and beautiful bangles, finely polished, unique design angles,charming bangles, catchy designs, 
Golwire Small, Golwire Medium, 1MM, 1.5MM, 2MM, 2.5MM, 3MM, 3.5MM, 4MM, 4.5MM, 5MM,5.2MM, 5/3MM, 5.5MM, 6MM, 6.5MM, 7MM, 7.2MM, 7/3MM, 7.8MM, 8MM, 8/3MM, 9MM, 9.2MM, 9/3MM, 10MM, 11MM, 11/3MM, 11/4MM, 11/5MM, 12MM, 12/3MM, 15MM, 19MM, 20MM, 20/3MM, 25MM, 
Imitation bangles,
Gold plated bangles, Gold Plated & Meena Bangles, Gold plated Mens kada, Gold plated bangles in Saudi Arabia are very unique and beautifully designed, gold dolphin bangle, silver dolphin bangle, gold plated bangles in Maharashtra, mumbai, Goregaon East, malad west, kandivali West,
Silver plated bangles, Mens Silver plated Punjabi kada,
Rhodium plated bangles,
2 tone bangles & bracelets, Rhodium & Gold plated, Silver & Gold plated,
3 tone bangles & bracelets set, Tri color bangles & bracelets set, 7 PCS semanario, Micro gold plated bangles & bracelets set, Rose gold plated bangles & bracelets set, Semanario bangles bracelets, Tri color lucky elephant bangle & bracelets, 3Tone Tri-Color Oro Laminado Bangle & Bracelets 6MM & 7MM set, Exporter of Three Tone Bangles set - Plane Three Tone Bangles set, 
Insha bangles, Green color pola, Red color pola, Maroon color pola, White color pola, Maharashtrian Green Insha Bangles, Gold Plated Acrylic Odisha Insha Bangles, Fancy Maroon Gold Plated Insha Bangles, Gold Plated Bengal Acrylic Insha Banglese, Red and White Gold Plated Insha Bangles,
Manufacturer of 3 Tone Bangles,
Engraving & etching 6MM/7MM/8MM/10MM/12MM/20mm/25MM 3Tone Guadalupe/Elephant/Dolphin bangle & bracelet,
etc."
        />
        <meta
          name="keywords"
          content={`${categoryList},${parentList},${stateList},${companyList}`}
        />
      </Helmet>

      <InshaHeader
        brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" textAlign="center" />}
        fixed
        color="transparent"
        changeColorOnScroll={{ height: 400, color: "dark" }}
      />

      <Parallax image={require("assets/img/bg4.png").default} className={classes.parallax}>
        <div className={classes.container}>
          {!activeSession && (
            <GridItem xs={12} sm={6} md={6}>
              <Dialog
                classes={{ root: js.modalRoot, paper: js.modal + " " + js.modalLogin }}
                open={loginModal}
                TransitionComponent={Transition}
                keepMounted
              >
                <Card plain className={js.modalLoginCard}>
                  <DialogTitle disableTypography className={js.modalHeader}>
                    <CardHeader plain color="rose" className={js.textCenter + " " + js.cardLoginHeader}>
                      <h5 className={js.cardTitleWhite}>Log in</h5>
                    </CardHeader>
                  </DialogTitle>
                  <DialogContent className={js.modalBody}>
                    {!otpScreen ? (
                      <form>
                        <CardBody className={js.cardLoginBody}>
                          <PhoneInput
                            country={"in"}
                            value={mobile}
                            inputStyle={{
                              width: "100%",
                              border: "none",
                              borderBottom: "1px solid #000",
                              borderRadius: "0",
                            }}
                            onChange={(value) => setMobile(value)}
                          />
                          <span style={{ color: "red" }}>{mobileErr}</span>
                        </CardBody>
                        <DialogActions className={js.justifyContentCenter}>
                          <Button color="rose" simple size="lg" 
                          // onClick={handleSendOtp}
                          >
                            Log in with OTP
                          </Button>
                          <Button color="rose" simple size="lg" href="/insha-register">
                            Create New Account
                          </Button>
                        </DialogActions>
                      </form>
                    ) : (
                      <form>
                        <p className={js.textCenter}>6-digit OTP has been sent to your number</p>
                        <CardBody className={js.cardLoginBody}>
                          <CustomInput
                            id="otpNumber"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "otpNumber",
                              value: otpNumber,
                              onChange: (e) => setOtpNumber(e.target.value),
                              placeholder: "Enter OTP here",
                              type: "text",
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Icon className={classes.inputIconsColor}>lock_outline</Icon>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <span style={{ color: "red" }}>{otpNumberErr}</span>
                        </CardBody>
                        <div className={classes.textCenter}>
                          <Button simple color="rose" size="lg" onClick={handleLogin}>
                            Log in
                          </Button>
                          <Button simple color="rose" size="lg" onClick={handleCallMe}>
                            <FiPhoneCall /> Call Me
                          </Button>
                        </div>
                      </form>
                    )}
                  </DialogContent>
                </Card>
              </Dialog>
            </GridItem>
          )}

          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1>INDIAN BANGLES</h1>
                <h3 className={classes.title}>
                  We have everything in Fashion and Style, Ready for every occasion and our designs never go out of Fashion.
                </h3>
                {/* {userLocation && (
                  <p style={{ marginTop: "15px", fontWeight: "bold" }}>
                    Your Location: Latitude {userLocation.lat.toFixed(5)}, Longitude {userLocation.lng.toFixed(5)}
                  </p>
                )} */}
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <InshaSection />
      </div>

      <InshaContact />
      <Footer />
    </div>
  );
}
